/**
 * Guest mode, as React sees it (AD-794 §6.2). Present ONLY inside a guest demo's game view; the
 * HUD and the Shell read it to hide the walled affordances and to show the demo banner. Absent
 * (null) everywhere else, so the main client renders byte-for-byte as before.
 */

import { createContext, useContext } from 'react';

import type { GuestCtaTarget } from './guestApi.js';
import type { GuestEndReason } from './guestFlow.js';

export interface GuestModeValue {
  registrationOpen: boolean;
  ctaTargets: readonly GuestCtaTarget[];
  /** End the demo now (the Menu's confirmed "End demo" passes `left`). */
  onEnd: (reason: GuestEndReason) => void;
}

export const GuestModeContext = createContext<GuestModeValue | null>(null);

/** The guest mode in force, or null on the main client. */
export function useGuestMode(): GuestModeValue | null {
  return useContext(GuestModeContext);
}
